module.exports = __webpack_public_path__ + "../resources/images/illustration_mention-08544967ae8303f5f0c7bc78a970a540.svg";